import getModelDataFromComponents from './getModelDataFromComponents';
import { CONFIG_ELEMENT_IDS } from './constants';
import dataFetcher from './dataFetcher';
import initializeOneTrust from './initializeOneTrust';
export const DATA_LAYER_READY_EVENT = 'e_dataLayerReady';
export const getConfigElement = (productLine) => {
    const config = CONFIG_ELEMENT_IDS[productLine] ? document.querySelector(CONFIG_ELEMENT_IDS[productLine]) : null;
    if (!config)
        return null;
    return config;
};
export const getConfigLanguage = (productLine) => {
    const config = getConfigElement(productLine);
    if (!config)
        return;
    return (config).dataset.language;
};
export const getPageTypeFromRoute = (route) => { var _a, _b, _c, _d, _e; return (_e = (_d = (_c = (_b = (_a = route === null || route === void 0 ? void 0 : route.fields) === null || _a === void 0 ? void 0 : _a.gtmPageType) === null || _b === void 0 ? void 0 : _b.fields) === null || _c === void 0 ? void 0 : _c.value) === null || _d === void 0 ? void 0 : _d.value) !== null && _e !== void 0 ? _e : 'others'; };
export const getUserContextUrl = (productLine) => {
    const config = getConfigElement(productLine);
    if (!config)
        return null;
    const hostname = config.dataset.siteHostname;
    return hostname ? `https://${hostname}/context` : config.dataset.userContextUrl;
};
export const getApiUrl = (productLine) => {
    var _a;
    const config = getConfigElement(productLine);
    if (!config)
        return null;
    const hostname = (_a = config.dataset.apiHostname) !== null && _a !== void 0 ? _a : config.dataset.hostname;
    return hostname && `https://${hostname}`;
};
export const pushGtmDataLayerReadyEvent = (payload) => {
    const dataLayer = typeof window !== 'undefined' && window.dataLayer ? window.dataLayer : [];
    // rm undefined values
    // eslint-disable-next-line no-param-reassign
    Object.keys(payload).forEach(key => !payload[key] && delete payload[key]);
    dataLayer.push(payload);
    // Fire other gtm events in queue afterwards
    const gtmQueue = typeof window !== 'undefined' && window.gtmQueue ? window.gtmQueue : [];
    if (Array.isArray(gtmQueue) && gtmQueue.length) {
        dataLayer.push(...gtmQueue);
        // clean up queue
        window.gtmQueue = null;
    }
};
export const gtmDataLayerHandler = async (route, appName, mainPlaceholderName, errorHandler) => {
    var _a, _b;
    const productLine = appName === null || appName === void 0 ? void 0 : appName.toLowerCase();
    const pageType = getPageTypeFromRoute(route);
    const language = getConfigLanguage(productLine);
    let payload = {
        pageType,
        locale: language,
        event: DATA_LAYER_READY_EVENT,
        query_params: '',
        userid: '',
        loginStatus: 'not logged in',
        numBuilds: undefined,
    };
    try {
        if (typeof window !== 'undefined') {
            const urlParamsStr = new URLSearchParams(window.location.search).toString();
            if (urlParamsStr)
                payload.query_params = `?${decodeURIComponent(urlParamsStr)}`;
        }
        // add model data to default payload
        const placeholderComponents = (route === null || route === void 0 ? void 0 : route.placeholders) ? route === null || route === void 0 ? void 0 : route.placeholders[mainPlaceholderName] : null;
        const modelPagePayload = getModelDataFromComponents(placeholderComponents, productLine);
        payload = { ...payload, ...modelPagePayload };
        const userContextUrl = getUserContextUrl(productLine);
        const apiUrl = getApiUrl(productLine);
        if (!userContextUrl || !apiUrl) {
            throw new Error(`API urls required for a GTM dataLayer push of user data could not be constructed. 
        apiUrl: ${apiUrl}; userContextUrl: ${userContextUrl};`);
        }
        const accountUrl = `${apiUrl}/accounts/me`;
        const buildsUrl = `${apiUrl}/builds?AcceptLanguage=${language}`;
        const userContext = await dataFetcher(userContextUrl);
        const isLoggedIn = userContext === null || userContext === void 0 ? void 0 : userContext.data.IsUserLoggedIn;
        if (isLoggedIn) {
            // add account and builds data to payload
            const authToken = (_b = (_a = userContext === null || userContext === void 0 ? void 0 : userContext.data) === null || _a === void 0 ? void 0 : _a.AccessToken) === null || _b === void 0 ? void 0 : _b.access_token;
            const account = await dataFetcher(accountUrl, null, authToken, false);
            const builds = await dataFetcher(buildsUrl, null, authToken, false);
            payload = {
                ...payload,
                userid: account === null || account === void 0 ? void 0 : account.data.Id,
                loginStatus: 'logged in',
                numBuilds: builds === null || builds === void 0 ? void 0 : builds.data.length.toString(),
            };
        }
        // push payload
        pushGtmDataLayerReadyEvent(payload);
    }
    catch (err) {
        const errorMessage = `gtmPageLoad: ${err}`;
        if (errorHandler) {
            errorHandler(errorMessage);
        }
        else {
            // eslint-disable-next-line no-console
            console.warn(errorMessage);
        }
        // push payload even if there is an error
        pushGtmDataLayerReadyEvent(payload);
    }
    // initialize OneTrust
    initializeOneTrust();
};
export default gtmDataLayerHandler;
